function getPostPosition(name: string, isObject: boolean) {
  const lastChar = name.charCodeAt(name.length - 1);
  if ((lastChar - 0xac00) % 28 > 0) {
    return isObject ? "을" : "과";
  }

  return isObject ? "를" : "와";
}

export default getPostPosition;

export function getPostPositionOfSubject(name: string) {
  const lastChar = name.charCodeAt(name.length - 1);
  if ((lastChar - 0xac00) % 28 > 0) {
    return "이";
  }

  return "가";
}
